export class SubscriptionRules {
    Id!: string;
    RuleName!: string;
    NumberOfGalleryProducts!: number;
    NumberOfArtistProducts!: number;
    NumberOfConnectionsAllowedToGallery!: number;
    NumberOfConnectionsAllowedToArtists!: number;
    NumberOfConsignmentProductAccepted!: number;
    NumberOfArtTypeSelection!: number;
    NumberOfArtistAIDescriptionCalls?: number;
    NumberOfGalleryAIDescriptionCalls?: number;
    NumberOfPortfolios?: number;
    NumberOfArtistPortfolios?: number;
    NumberOfGalleryPortfolios?: number;
    IsActive!: boolean;
    CreatedAt!: Date;
    ClosingAt!: Date;
    User!: null;
}

export class SaveSubscriptionRulesRequest {
    Id?: string;
    RuleName?: string;
    NumberOfGalleryProducts?: number;
    NumberOfArtistProducts?: number;
    NumberOfConnectionsAllowedToGallery?: number;
    NumberOfConnectionsAllowedToArtists?: number;
    NumberOfConsignmentProductAccepted?: number;
    NumberOfArtTypeSelection?: number;
    NumberOfArtistAIDescriptionCalls?: number;
    NumberOfGalleryAIDescriptionCalls?: number;
    NumberOfArtistPortfolios?: number;
    NumberOfGalleryPortfolios?: number;
    IsActive?: boolean;
    CreatedAt?: Date;
    ClosingAt?: Date;
    appFeaturePermissionDto!: AppFeaturePermissionDto[];
}

export class AppFeaturePermissionDto {
    Id!: string;
    SubscriptionRuleSetId!: string;
    FeatureId!: string;
    FeatureKey!: string;
    FeatureLabel!: string;
    FeatureFor!: string;
    IsEnabled!: boolean;
}

export class SubscriptionRuleSetUsers {
    Id!: string;
    Name!: string;
    Email!: string;
    BusinessName?: string;
    ProfileImageUrl?: string;
    BusinessImageUrl?: string;
    PhoneNumber!: null | string;
    IsArtist!: boolean;
    CreatedDate!: Date;
}

